export default {
    contractSummary: {
        title: 'Contract summary',
        editContract: 'Edit contract',
        newContract: '+ New contract',
        counterparty: 'Counterparty',
        profileSource: 'Profile source',
        tenor: 'Tenor',
        delivery: 'Delivery',
        totalVolume: 'Total volume',
        price: 'Price',
        version: 'Version',
    },
}
